<template>
  <div class="share-card" @click.stop v-if="data">
    <div class="card-content">
      <div class="card-scroll">
        <img class="share-image" :src="data.share" alt="" @click="bindClose" />
      </div>
      <div class="back" @click="bindClose">返回</div>
    </div>
    <div class="fixed">
      <div class="btn-item btn-left" @click="bindSave">点击保存结果</div>
      <img
        class="btn-item btn-right"
        v-buried
        v-clickBuried
        data-click-buried="CLICK_CQHD_JQFX"
        data-buried="BG_CQHD_JQFX"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d3a4120ca2f8f981607abcedde5f7053.png"
        @click="bindShare"
        alt=""
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  methods: {
    bindClose() {
      this.$emit('close')
    },
    bindSave() {
      this.$emit('save', this.data.share)
    },
    bindShare() {
      this.$emit('share', this.data)
    }
  }
}
</script>
<style lang="scss" scoped>
.share-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;

  .card-content {
    position: relative;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;

    .card-scroll {
      height: 100%;
      overflow: scroll;
    }
    .back {
      position: absolute;
      border-radius: 50%;
      color: #fff;
      right: 20px;
      bottom: 30px;
      width: 40px;
      height: 40px;
      line-height: 40px;
      white-space: nowrap;
      text-align: center;
      background-color: rgb(113, 143, 234);
    }
    .share-image {
      width: 100%;
    }
  }

  .fixed {
    padding: 7px 30px;
    padding-bottom: 27px;
    background-color: #fff;
    display: flex;
    align-items: center;
    @include paddingBottom(27px);

    .btn-item {
      text-align: center;
      height: 34px;
      border-radius: 17px;
      font-size: 12px;
      font-family: MiSans-Demibold, MiSans;
      font-weight: 600;
      line-height: 34px;
    }

    .btn-left {
      width: 172px;
      background-color: #fff;
      border: 1px solid #605989;
      color: #605989;
      margin-right: 3px;
    }

    .btn-right {
      width: 140px;
    }
  }
}
</style>
